/**
 * Copy-to-clipboard icon button for identifiers (job ids, artifact ids).
 * Falls back silently-with-a-toast when the Clipboard API is unavailable
 * (plain-HTTP deployments); stops row-click propagation so it can live
 * inside clickable table rows.
 */
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import { useToast } from "../../hooks/useToast";

export function CopyIdButton({ value, label }: { value: string; label?: string }) {
  const { t } = useTranslation();
  const toast = useToast();
  const title = label ?? t("common.copyId");

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast(t("common.copied"), "success");
    } catch {
      toast(t("common.copyFailed"), "error");
    }
  }

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        aria-label={`${title} — ${value}`}
        onClick={(e) => {
          e.stopPropagation();
          void copy();
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
